import type {Schemas} from 'api/dto.generated';
import {ebsApi} from 'store/ebsApi';
import type {SystemHealth} from './types';
import {mapHealthCheckDto} from './mappers/mapHealthCheckDto';

export const healthcheckApi = ebsApi.injectEndpoints({
  endpoints: builder => ({
    getHealthcheck: builder.query<SystemHealth, void, Schemas.HealthcheckDto>({
      query: () => ({
        url: '/healthcheck',
        method: 'GET',
      }),
      keepUnusedDataFor: 60,
      transformResponse: mapHealthCheckDto,
    }),
  }),
  overrideExisting: false,
});

export const {useGetHealthcheckQuery} = healthcheckApi;
